import React from 'react';
import PropTypes from 'prop-types';

const POIReviewCount = (props) => {

  return (
    <div className="showcase-row__badge">
      <i className="fa fa-commenting-o" aria-hidden="true"/>
      <span>{props._source.reviews_count}</span>
    </div>
  )
}

POIReviewCount.propTypes = {
  _source: PropTypes.shape({
    reviews_count: PropTypes.number
  })
};

export default POIReviewCount;



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/searchBox/POIListItems/POIReviewCount.jsx